import { render, staticRenderFns } from "./CategoriaSelectComponent .vue?vue&type=template&id=b680a730&"
import script from "./CategoriaSelectComponent .vue?vue&type=script&lang=js&"
export * from "./CategoriaSelectComponent .vue?vue&type=script&lang=js&"
import style0 from "./CategoriaSelectComponent .vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports